'use strict';

export default angular
  .module('maestro.filters.userName', [])

  .filter('userName', function($filter) {
    let $t = $filter('translate');
    return function(user) {
      let str = '';
      if (!user) {
        return $t('common.unknownUser');
      }
      if (user.firstName) {
        str += user.firstName;
      }
      if (user.lastName) {
        str += ' ' + user.lastName;
      }
      if (!str) {
        str = $t('common.unknownUser');
      }
      return str;
    };
  })

  .name;
